import { ENV_KEYS } from "../../constants";

export const EXPERIMENT_KEY =
  "qfd-374-replace-beta-program-by-amplitude-experiment";
export const DEPLOYMENT_KEY = ENV_KEYS.tvg.web;

export const TVG5_COOKIE = "useTvg5";
